// extracted by mini-css-extract-plugin
module.exports = {"terms-conditions":"terms_terms-conditions__NiqHX","terms-conditions--v1":"terms_terms-conditions--v1__OZdJf"};